import type { ColProps } from "antd";
import { Col } from "antd";
import type { FC } from "react";

export interface IotColProps extends ColProps {
    show?: boolean;
}

export const IotCol: FC<IotColProps> = (props) => {
    const { show, ...restProps } = props;

    if (show === false) return null;

    return <Col {...restProps} />;
};
